export enum GemCertificate {
  ICL = 'ICL',
  GIA = 'GIA',
  AGL = 'AGL',
  GRS = 'GRS',
  CDC = 'CDC',
  AGS = 'AGS',
  DSEF = 'DSEF',
  EGL = 'EGL',
  FGL = 'FGL',
  GCAL = 'GCAL',
  GGL = 'GGL',
  HRD = 'HRD',
  IGI = 'IGI',
  AIGS = 'AIGS',
  LOTUS = 'LOTUS',
  GUBELIN = 'GUBELIN',
  RGL = 'RGL',
  TGL = 'TGL',
  ALGT = 'ALGT',
  Other = 'Other',
  AnyCert = 'Any Cert',
  None = 'None',
  Nil = 'NIL',
}
